import { render, staticRenderFns } from "./RightAlign.vue?vue&type=template&id=ce707032"
import script from "./RightAlign.vue?vue&type=script&lang=js"
export * from "./RightAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports